<template>
  <div class="tag-base" :class="tagClass">
    {{ label }}
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

const VARIANT_VALUES = ["outlined", "contained"] as const;
type VariantType = typeof VARIANT_VALUES[number];

@Component
export default class Tag extends Vue {
  @Prop({
    default: "outlined",
    type: String,
    validator: prop => VARIANT_VALUES.includes(prop as VariantType)
  })
  variant!: VariantType;

  @Prop({
    required: true,
    type: String
  })
  label!: string;

  get isOutlinedStyle() {
    return this.variant === "outlined";
  }

  get tagClass() {
    return this.isOutlinedStyle ? "tag-outlined" : "";
  }
}
</script>

<style lang="scss" scoped>
.tag-base {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  font-size: 14px;
  line-height: 19px;
  color: $gray-05;
  text-align: center;
  background-color: $white;
  border-radius: 4px;
}

.tag-outlined {
  border: 1px solid $gray-03;
}
</style>
